import DateRangeInput from './DateRangeInput';

// export types
export type { DateRangeInputProps } from './DateRangeInput';

// export components
export { DateRangeInput };
export default DateRangeInput;
